import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HelperTooltip = function HelperTooltip(_ref) {
  var title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-w-[208px] tw-whitespace-normal",
    children: [/*#__PURE__*/_jsx("p", {
      className: "tw-font-subtitle5",
      children: title
    }), /*#__PURE__*/_jsx("p", {
      className: "tw-font-body5 tw-mt-0.4 tw-whitespace-normal",
      children: description
    })]
  });
};